Sofatutor.tracking.startEventForVideoAndExerciseWatched = function(
  category,
  label,
  dimensions
  ) {

  if (!Sofatutor.consentGivenForCategory('functionality')) { return; }

  var counterpartOfCategory,
    videoOrExerciseStartCookie = '_sofatutor_video_or_exercise_start',
    cookieExpireTime = 365 * 20;

  if (category == 'video') {
    counterpartOfCategory = 'exercise';
  } else if (category == 'exercise') {
    counterpartOfCategory = 'video';
  }

  if (!!$.cookie(videoOrExerciseStartCookie)) {
    if ($.cookie(videoOrExerciseStartCookie) != category) {
      // Bing
      window.uetq.push({
        ec: category,
        ea: 'start_and_' + counterpartOfCategory + '_start',
        ev: '0'
      });
    }

    if ($.cookie(videoOrExerciseStartCookie) == counterpartOfCategory) {
      $.cookie(videoOrExerciseStartCookie, 'both', {
        expires: cookieExpireTime
      });
    }
  } else {
    $.cookie(videoOrExerciseStartCookie, category, {
      expires: cookieExpireTime
    });
  }
};

Sofatutor.tracking.amplitudeBasicExerciseStartedEvent = function() {
  var question = $('.shared-feature-question');
  var amplitudeBasicExerciseProperties = {
    exercise_id: question.data('trackedLabel').split('|')[1],
    exercise_product: 'basic_exercise',
    subject: question.data('dimensions-dimension1'),
    video_id: question.data('exercisesPropertiesVideoId'),
    topic_id: question.data('exercisesPropertiesTopicId'),
    teacher_link: question.data('exercisesPropertiesTeacherLink') ? question.data('exercisesPropertiesTeacherLink') : false,
    bookmarked_video: question.data('exercisePropertiesBookmarkedVideo')? question.data('exercisesPropertiesBookmarkedVideo') : false
  };

  Sofatutor.tracking.amplitude.track(
    'exercise_started',
    amplitudeBasicExerciseProperties
  );
};
